// Core editor - handles both plain text and rich text
export { Editor as CoreEditor, type EditorProps, type EditorRefHandle } from "@/components/lexical/editors/core"

// Email editor - special formatting for email content
export { default as EmailEditor } from "@/components/lexical/editors/email"

// Markdown readonly editor - display-only markdown content
export { MarkdownReadonly } from "@/components/lexical/editors/markdown-readonly"

// Re-export the default Editor for backward compatibility
export { Editor } from "@/components/lexical/editors/core"
